// Lead Search Dropdown
export const LeadSearchDropdown = [
  { name: "Mobile", value: "mobile" },
  { name: "Lead ID", value: "leadID" },
  { name: "Loan A/c Number", value: "loanNo" },
  { name: "Customer ID", value: "customerID" },
  { name: "Name", value: "name" },
  { name: "Email", value: "email" },
  { name: "PAN", value: "pan" },
  { name: "Razorpay OrderId", value: "razorpayOrderId" },
  { name: "Razorpay PaymentId", value: "razorpayPaymentId" },
  { name: "Disbursal AccountNo", value: "disbursalAccountNo" },
];

// Lead Status Reason Dropdown
export const LeadStatusReasonDropdown = {
  Hold: [
    "Bad Cibil",
    "EMI Bouncing",
    "A Lot Payday Loans Running",
    "Current Address Proof Not Available",
    "Negative Area",
    "Bad Recovery Track",
    "Small Company",
    "Edited Documents",
    "Rude Behaviour",
    "Salary not credited",
    "Other",
    "Out of Range",
    "No answer",
    "Approved",
  ],
  Rejected: [
    "Bad Cibil",
    "EMI Bouncing",
    "A Lot Payday Loans Running",
    "Current Address Proof Not Available",
    "Negative Area",
    "Bad Recovery Track",
    "Small Company",
    "Edited Documents",
    "Rude Behaviour",
    "Salary not credited",
    "Other",
    "Out of Range",
    "No answer",
    "Approved",
    "High DPD (8-15)",
  ],
  "Not Required": ["Want High Amount", "High ROI", "Will Apply Later", "Want EMI Loan", "Not Contactable", "Requirement Fulfill", "Customer refused"],
  "Rejected Process": [
    "Incomplete documents",
    "Fraud Documents",
    "Language Issue",
    "Low ABB",
    "Low Salary",
    "Negative Profile",
    "Not Contactable",
    "Not Interested",
    "New to Credit",
    "Current Address Proof Not Available",
    "EMI Bouncing",
    "Salary not credited",
    "Policy Norms Not Met",
  ],
  "Hold Process": [
    "Incomplete documents",
    "Fraud Documents",
    "Language Issue",
    "Low ABB",
    "Low Salary",
    "Negative Profile",
    "Not Contactable",
    "Not Interested",
    "New to Credit",
    "Current Address Proof Not Available",
    "EMI Bouncing",
    "Salary not credited",
    "Policy Norms Not Met",
  ],
  "Not Required Process": ["Documents Required", "Salary Not Verified/Low Abb", "Tech Issue", "High ROI/PF", "Want High Amount", "Not Required Now"],
  Blacklist: ["DPD too High", "RBI Escalations raised by User"],
  Blacklisted: ["DPD too High", "RBI Escalations raised by User", "Name Mismatch", "Author Fraud", "Others"],
};

// Process Fee
export const ProcessingFee = ["5", "6", "7", "8", "9", "10"];

// Rio
// export const RioFee = ["1.00", ...Array.from({ length: 100 }, (_, i) => (i / 100).toFixed(2))];
export const RioFee = Array.from({ length: 51 }, (_, i) => (1 - i * 0.01).toFixed(2));

// Tenure
export const Tenure = ["2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

export const EMI_ROI_LIST = Array.from({ length: 169 }, (_, i) => ({ label: `${i + 12}%`, value: `${i + 12}` }));

// Badge Status (red, orange, yellow, green, cyan, blue, violet)
export const BadgeStatus = {
  // Employment History
  ["Not Verified"]: "red",
  "Not Deleted": "green",
  ["Yes"]: "green",
  ["No"]: "red",
  Deleted: "red",

  Unverified: "violet",

  // Timeline
  ivr: "cyan",
  ["Allocate Document Received"]: "violet",
  ["Upload Document"]: "blue",
  ["Add Address"]: "yellow",
  ["Add Reference No"]: "orange",
  ["Add employee"]: "cyan",
  ["sanction-letter"]: "yellow",
  Emandate: "blue",
  ["Disbursed By Razorpay"]: "cyan",
  ["disbursal-letter"]: "orange",
  ["Allocate Approved Process"]: "blue",
  ["Allocate Hold Process"]: "yellow",
  ["loan-close"]: "red",
  ["not_answring_call"]: "red",
  ["alining_visit"]: "cyan",
  ["no_cash"]: "orange",
  ["repeatedly_making_commitments"]: "yellow",
  ["creditReminderMailSend"]: "orange",
  ["do_not_make_cash_payment"]: "red",
  ["not_paid_anything"]: "cyan",
  ["one_day_before_due_date"]: "yellow",
  ["not_getting_salary"]: "orange",
  ["four_days_before_due_date"]: "blue",
  ["left_home_and_not_paid"]: "blue",
  ["sanction-letter-resend"]: "orange",
  ["sameDayReminderMailSend"]: "yellow",
  ["Disbursed By Razorpay1"]: "blue",
  ["Allocate Disbursal sheet send"]: "cyan",
  ["Disbursed By Razorpay Failed"]: "blue",
  ["Document Upload"]: "green",
  ["Contacts Added"]: "yellow",
  ["E-mandate"]: "orange",
  ["Pennydrop Acc. Validation"]: "violet",
  ["Account Update"]: "violet",
  ["Aadhar Added"]: "violet",
  ["Lead Allocated"]: "cyan",
  ["Disbursal Account Updated"]: "green",
  ["name-missmatch"]: "yellow",
  ["Unblacklisted"]: "orange",
  ["Pan Aadhaar Linked Checks"]: "cyan",
  ["Agreement Sent"]: "yellow",
  ["_NR"]: "yellow",
  ["_NC"]: "violet",
  Nc: "orange",
  ["In Queue"]: "blue",
  Initiated: "violet",
  Cancelled: "cyan",
  queued: "yellow",
  ["SOA Sent"]: "orange",
  ["Closed with Blacklist"]: "yellow",
  ["Payment Mode Update"]: "cyan",
  Success: "green",
  Assign: "blue",

  // Penny Drop
  completed: "green",
  created: "orange",
  failed: "red",
  invalid: "red",
  Inactive: "red",
  active: "green",

  // E- Mandate Details
  issue: "red",

  //Pancard

  ["Deactive"]: "red",

  incomplete: "cyan",
  unknown: "blue",
  rejected: "red",
  name_mismatch: "violet",

  // Collection Details
  Approved: "green",
  Rejected: "red",
  Captured: "orange",
  Accepted: "cyan",
  Pending: "blue",

  Processing: "orange",
  Completed: "green",
  Failed: "red",

  // Collection Follow Up
  ["Payment Rejected"]: "red",
  ["Approved-rejected"]: "red",
  ["Payment Rejected (Approved)"]: "orange",
  ["Approval Waiting (refunded amount)"]: "cyan",
  ["Approved-refunded"]: "violet",
  ["Approval Waiting"]: "yellow",
  ["Payment Rejected"]: "red",
  ["Apprved-rejected"]: "red",
  ["Approved-Rejected"]: "red",
  ["Not Contactable"]: "cyan",
  Ringing: "violet",
  PTP: "cyan",
  ["FI Home"]: "yellow",
  ["Disconnected the Call"]: "orange",
  Busy: "violet",
  ["Out Of Network"]: "cyan",
  ["Switch Off"]: "yellow",
  ["FI Office"]: "blue",
  Spoken: "orange",
  ["Not Comfortable"]: "red",
  ["Not at home location"]: "red",
  ["Pending in App"]: "blue",
  ["Document Pending"]: "yellow",
  ["H Block"]: "violet",

  // Documents Details
  SUCCESS: "green",
  PENDING: "orange",
  Failed: "red",
  fail: "red",
  ["SUCCESS crm mannul"]: "green",
  PAID: "cyan",
  Verified: "green",

  // Lead Status
  ["Fresh Lead"]: "cyan",
  Callback: "orange",
  Interested: "green",
  ["Not Interested"]: "red",
  ["Document Received"]: "green",
  Hold: "violet",
  ["Disbursal Sheet Send"]: "yellow",
  Disbursed: "blue",
  ["Part Payment"]: "yellow",
  Settlement: "orange",
  ["Incomplete Documents"]: "red",
  DNC: "violet",
  ["Not Eligible"]: "red",
  Duplicate: "red",
  ["No Answer"]: "yellow",
  ["Bank Update Rejected"]: "red",
  ["Approved Process"]: "cyan",
  ["Rejected Process"]: "red",
  ["Hold Process"]: "blue",
  ["Not Required"]: "orange",
  ["Not Required Process"]: "cyan",
  Blacklisted: "violet",
  ["Disbursal Approved"]: "green",
  ["Incomplete User"]: "orange",
  Closed: "red",
  issued: "red",
  paid: "green",
  partial: "orange",
  cancelled: "cyan",
  expired: "red",
  ["Part Payment"]: "yellow",
  Paid: "green",
  ["Part Paid"]: "orange",
  Due: "blue",
  Overdue: "red",
  ["In Active"]: "red",
  Active: "green",

  // Emi Schedule
  due: "blue",
  ["partially-paid"]: "orange",
  ["Partial Update"]: "orange",

  // Waive Off
  ["EMI Closed"]: "violet",

  // Name Match , Dob Match , Pan AAdhar Match
  getPercentageColor: (percentage) => {
    if (percentage === 100) return "green";
    if (percentage >= 71 && percentage <= 89) return "orange";
    return "red"; // Below 70%
  },
};

// Logs
export const Logs = {
  Supplier: [
    { name: "Decentro", value: "1" },
    { name: "Finbox", value: "2" },
    { name: "Cibil", value: "3" },
    { name: "Surepass", value: "4" },
  ],
};

// annum days
export const AnnumDayList = {
  AnnumDay: [
    { label: "par day", value: 2 },
    { label: "par annum", value: 1 },
  ],
};

// Refund Page Nav List
export const RefundNavList = {
  NavList: [
    { key: "refund-transactions", label: "Refund Transactions" },
    { key: "csv-upload", label: "CSV Upload" },
    { key: "upload-status", label: "Upload Status" },
  ],
};

export const csvRequirements = ["loanNo", "amount", "paymentID", "orderID"];
// refund search By Keys
export const searchByKeys = [
  { key: "loan_no", value: "Loan No" },
  { key: "lead_id", value: "Lead ID" },
  { key: "payment_id", value: "Payment ID" },
  { key: "order_id", value: "Order ID" },
  { key: "mobile", value: "Mobile No." },
];
//refund User Status Dropdown
export const refundUserStatusDropdown = [
  { label: "All Transactions", value: "All" },
  { label: "Success", value: "Success" },
  { label: "Pending", value: "Pending" },
  { label: "Failed", value: "Failed" },
];

// Active Inactive status Options
export const statusOptions = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 0 },
];
export const LEAD_STATUS_CONSTANTS = {
  CLOSED: "Closed",
  AML_REJECTED: "AML Rejected",
  CANCELLED: "Cancelled"
};

export const LEAD_STATUS = {
  FRESH_LEAD: "Fresh Lead",
  CALLBACK: "Callback",
  INTERESTED: "Interested",
  NOT_INTERESTED: "Not Interested",
  WRONG_NUMBER: "Wrong Number",
  DOCUMENT_RECEIVED: "Document Received",
  APPROVED: "Approved",
  HOLD: "Hold",
  DISBURSAL_SHEET_SEND: "Disbursal Sheet Send",
  DISBURSED: "Disbursed",
  CLOSED: "Closed",
  PART_PAYMENT: "Part Payment",
  SETTLEMENT: "Settlement",
  INCOMPLETE_DOCUMENTS: "Incomplete Documents",
  DNC: "DNC",
  REJECTED: "Rejected",
  NOT_ELIGIBLE: "Not Eligible",
  DUPLICATE: "Duplicate",
  OTHER: "Other",
  NO_ANSWER: "No Answer",
  EMI_PAID: "EMI Paid",
  LESS_SALARY: "Less Salary",
  OUT_OF_RANGE: "Out of Range",
  EMI_PRECLOSE: "EMI PRECLOSE",
  BANK_UPDATE_REJECTED: "Bank Update Rejected",
  APPROVED_PROCESS: "Approved Process",
  REJECTED_PROCESS: "Rejected Process",
  HOLD_PROCESS: "Hold Process",
  NOT_REQUIRED: "Not Required",
  NOT_REQUIRED_PROCESS: "Not Required Process",
  BLACKLISTED: "Blacklisted",
  DISBURSAL_APPROVED: "Disbursal Approved",
  BANK_UPDATE_HOLD: "Bank Update Hold",
  INCOMPLETE_USER: "Incomplete User",
  AML_HIT:"AML Hit",
  AML_REJECTED: "AML Rejected",

};

export const ROLES = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  CALLING_EXECUTIVE: 'Calling Executive',
  COLLECTION_EXECUTIVE: 'Collection Executive'
}

export const PERMISSIONS = {
  PII_VAULT_ACCESS: 'PII_VAULT_ACCESS',
  PII_LOG_DOWNLOAD_ACCESS: 'pii_download_access',
  PII_ACCESS_LOG_LIST :'pii_access_log_list'
}